/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  CashDrawerBase,
  CashDrawerBaseOptional,
  CashDrawerBaseMetaI,
  CashDrawerBaseTrackedI,
} from "./cash-drawer-base";
import { CashDrawerBaseTracked, CashDrawerBaseMeta } from "./cash-drawer-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CashDrawerRef,
  CashDrawerRefOptional,
  CashDrawerRefMetaI,
  CashDrawerRefTrackedI,
} from "./cash-drawer-ref";
import { CashDrawerRefTracked, CashDrawerRefMeta } from "./cash-drawer-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PrinterRef,
  PrinterRefOptional,
  PrinterRefMetaI,
  PrinterRefTrackedI,
} from "./printer-ref";
import { PrinterRefTracked, PrinterRefMeta } from "./printer-ref";

/**
 *
 * @export
 * @interface CashDrawerFull
 */
export interface CashDrawerFullOptional extends CashDrawerBaseOptional {
  /**
   *
   * @type {boolean}
   * @memberof CashDrawerFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CashDrawerFull
   */
  isNew?: boolean;
  /**
   *
   * @type {string}
   * @memberof CashDrawerFull
   */
  cashDrawerName?: string;
  /**
   *
   * @type {string}
   * @memberof CashDrawerFull
   */
  cashDrawerPrinterIp?: string;
  /**
   *
   * @type {string}
   * @memberof CashDrawerFull
   */
  cashDrawerId?: string;
  /**
   *
   * @type {PrinterRef}
   * @memberof CashDrawerFull
   */
  printer?: PrinterRefOptional;
}

export interface CashDrawerFull
  extends CashDrawerFullOptional, CashDrawerBase, CashDrawerRef, Deletable {
  /**
   *
   * @type {boolean}
   * @memberof CashDrawerFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CashDrawerFull
   */
  isNew?: boolean;
  /**
   *
   * @type {string}
   * @memberof CashDrawerFull
   */
  cashDrawerName: string;
  /**
   *
   * @type {string}
   * @memberof CashDrawerFull
   */
  cashDrawerPrinterIp?: string;
  /**
   *
   * @type {string}
   * @memberof CashDrawerFull
   */
  cashDrawerId: string;
  /**
   *
   * @type {PrinterRef}
   * @memberof CashDrawerFull
   */
  printer?: PrinterRef;
}

export interface CashDrawerFullTrackedI extends CashDrawerBaseOptional {
  /**
   *
   * @type {boolean}
   * @memberof CashDrawerFull
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CashDrawerFull
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CashDrawerFull
   */
  cashDrawerName?: string;
  cashDrawerNameIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CashDrawerFull
   */
  cashDrawerPrinterIp?: string;
  cashDrawerPrinterIpIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CashDrawerFull
   */
  cashDrawerId?: string;
  cashDrawerIdIsSet: boolean;
  /**
   *
   * @type {PrinterRef}
   * @memberof CashDrawerFull
   */
  printer?: PrinterRefTrackedI;
  printerIsSet: boolean;
}

transformDatesMap.set("CashDrawerFull", function (model: CashDrawerFull) {
  const transformDatesprinter = transformDatesMap.get("PrinterRef");
  if (transformDatesprinter && model.printer) {
    transformDatesprinter(model.printer);
  }
});

export type CashDrawerFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  cashDrawerName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  cashDrawerPrinterIp: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  cashDrawerId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  printer: PropertyMeta<PrinterRefMetaI>;
}>;

export var CashDrawerFullMeta: CashDrawerFullMetaI = {} as CashDrawerFullMetaI;
CashDrawerFullMeta = typeMeta("CashDrawerFull", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  cashDrawerName: propertyMeta(
    "cashDrawerName",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  cashDrawerPrinterIp: propertyMeta(
    "cashDrawerPrinterIp",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  cashDrawerId: propertyMeta(
    "cashDrawerId",
    false,
    true,
    true,
    MetaTypesBase.string,
  ),
  printer: propertyMeta("printer", false, false, false, PrinterRefMeta),
});

const metaI = CashDrawerFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
  metaI.interfaces = metaI.interfaces.concat([CashDrawerBaseMeta]);
  metaI.cashDrawerName.inheritedFrom = CashDrawerBaseMeta.cashDrawerName;
  metaI.cashDrawerPrinterIp.inheritedFrom =
    CashDrawerBaseMeta.cashDrawerPrinterIp;
  metaI.interfaces = metaI.interfaces.concat([CashDrawerRefMeta]);
  metaI.cashDrawerId.inheritedFrom = CashDrawerRefMeta.cashDrawerId;
});

export class CashDrawerFullTracked
  extends CashDrawerBaseTracked
  implements CashDrawerFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  cashDrawerName__I?: string = undefined;
  cashDrawerNameIsSet: boolean = false;
  set cashDrawerName(v: undefined | string) {
    if (v !== undefined) {
      this.cashDrawerName__I = v;
      this.cashDrawerNameIsSet = true;
    } else {
      this.cashDrawerName__I = v || undefined;
      this.cashDrawerNameIsSet = true;
    }
    this.changeTracker = true;
  }
  get cashDrawerName() {
    return this.cashDrawerName__I;
  }
  cashDrawerPrinterIp__I?: string = undefined;
  cashDrawerPrinterIpIsSet: boolean = false;
  set cashDrawerPrinterIp(v: undefined | string) {
    if (v !== undefined) {
      this.cashDrawerPrinterIp__I = v;
      this.cashDrawerPrinterIpIsSet = true;
    } else {
      this.cashDrawerPrinterIp__I = v || undefined;
      this.cashDrawerPrinterIpIsSet = false;
    }
    this.changeTracker = true;
  }
  get cashDrawerPrinterIp() {
    return this.cashDrawerPrinterIp__I;
  }
  cashDrawerId__I?: string = undefined;

  get cashDrawerIdIsSet() {
    return this.cashDrawerId !== undefined;
  }
  set cashDrawerIdIsSet(v: boolean) {}
  set cashDrawerId(v: undefined | string) {
    if (v !== undefined) {
      this.cashDrawerId__I = v;
      this.cashDrawerIdIsSet = true;
    } else {
      this.cashDrawerId__I = v || undefined;
      this.cashDrawerIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get cashDrawerId() {
    return this.cashDrawerId__I;
  }
  printer__I?: PrinterRefTracked = undefined;
  printerIsSet: boolean = false;
  set printer(v: undefined | PrinterRefTracked) {
    if (v !== undefined) {
      this.printer__I = v;
      this.printerIsSet = true;
    } else {
      this.printer__I = v || undefined;
      this.printerIsSet = false;
    }
    this.changeTracker = true;
  }
  get printer() {
    return this.printer__I;
  }
  constructor(config?: CashDrawerFullOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.cashDrawerIdIsSet == true && other?.cashDrawerIdIsSet == true)
      return this.cashDrawerId == other.cashDrawerId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.cashDrawerId) {
      this.cashDrawerIdIsSet = true;
    }

    this.printer?.setIds();
  }
  assignFrom(
    config: CashDrawerFullOptional,
    options?: AssignOptions,
  ): CashDrawerFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (
      config.cashDrawerName &&
      this.cashDrawerNameApplyFilter(optionsRequired.filter)
    ) {
      this.cashDrawerName = config.cashDrawerName;
      if (optionsRequired.unassign) this.cashDrawerNameIsSet = false;
      else this.cashDrawerNameIsSet = true;
    }
    if (
      config.cashDrawerPrinterIp &&
      this.cashDrawerPrinterIpApplyFilter(optionsRequired.filter)
    ) {
      this.cashDrawerPrinterIp = config.cashDrawerPrinterIp;
      if (optionsRequired.unassign) this.cashDrawerPrinterIpIsSet = false;
      else this.cashDrawerPrinterIpIsSet = true;
    }
    if (
      config.cashDrawerId &&
      this.cashDrawerIdApplyFilter(optionsRequired.filter)
    ) {
      this.cashDrawerId = config.cashDrawerId;
      if (optionsRequired.unassign) this.cashDrawerIdIsSet = false;
      else this.cashDrawerIdIsSet = true;
    }
    if (config.printer && this.printerApplyFilter(optionsRequired.filter)) {
      this.printer = new PrinterRefTracked(config.printer, options);
      if (optionsRequired.unassign) this.printerIsSet = false;
      else this.printerIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CashDrawerFullTrackedI {
    const cloned = {} as CashDrawerFullTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.cashDrawerNameIsSetDeep() &&
      this.cashDrawerNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cashDrawerNameIsSet = true;
      cloned.cashDrawerName = this.cashDrawerName;
    } else {
      //cloned.cashDrawerNameIsSet = false
    }
    if (
      this.cashDrawerPrinterIpIsSetDeep() &&
      this.cashDrawerPrinterIpApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cashDrawerPrinterIpIsSet = true;
      cloned.cashDrawerPrinterIp = this.cashDrawerPrinterIp;
    } else {
      //cloned.cashDrawerPrinterIpIsSet = false
    }
    if (
      this.cashDrawerIdIsSetDeep() &&
      this.cashDrawerIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cashDrawerIdIsSet = true;
      cloned.cashDrawerId = this.cashDrawerId;
    } else {
      //cloned.cashDrawerIdIsSet = false
    }
    if (
      this.printerIsSetDeep() &&
      this.printerApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.printerIsSet = true;
      cloned.printer = this.printer?.removeUnset(filter);
    } else {
      //cloned.printerIsSet = false
    }
    if (!isDeleted(this) && !this.cashDrawerIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CashDrawerFullTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.cashDrawerNameApplyFilter(filter))
      this.cashDrawerNameIsSet = false;

    if (!this.cashDrawerPrinterIpApplyFilter(filter))
      this.cashDrawerPrinterIpIsSet = false;

    if (!this.cashDrawerIdApplyFilter(filter)) this.cashDrawerIdIsSet = false;

    if (!this.printerApplyFilter(filter)) this.printerIsSet = false;
    this.printer?.unassignAll(filter);

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CashDrawerFullMeta.isDeleted,
      CashDrawerFullMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CashDrawerFullMeta.isNew,
      CashDrawerFullMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  cashDrawerNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CashDrawerFullMeta.cashDrawerName,
      CashDrawerFullMeta,
      this.cashDrawerName,
      this,
    );
  }
  cashDrawerNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.cashDrawerNameIsSet && this.cashDrawerNameApplyFilter(filter))
      return true;

    return false;
  }
  cashDrawerPrinterIpApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CashDrawerFullMeta.cashDrawerPrinterIp,
      CashDrawerFullMeta,
      this.cashDrawerPrinterIp,
      this,
    );
  }
  cashDrawerPrinterIpIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.cashDrawerPrinterIpIsSet &&
      this.cashDrawerPrinterIpApplyFilter(filter)
    )
      return true;

    return false;
  }
  cashDrawerIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CashDrawerFullMeta.cashDrawerId,
      CashDrawerFullMeta,
      this.cashDrawerId,
      this,
    );
  }
  cashDrawerIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.cashDrawerIdIsSet && this.cashDrawerIdApplyFilter(filter))
      return true;

    return false;
  }
  printerApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CashDrawerFullMeta.printer,
      CashDrawerFullMeta,
      this.printer,
      this,
    );
  }
  printerIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.printerIsSet && this.printerApplyFilter(filter)) return true;
    return this.printer?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.cashDrawerNameIsSetDeep(filter)) return true;
    if (this.cashDrawerPrinterIpIsSetDeep(filter)) return true;
    if (this.cashDrawerIdIsSetDeep(filter)) return true;
    if (this.printerIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
